
  <input class="input" type="text" placeholder="Time">
   